__webpack_require__.p = "/fptpayment/";